var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgStub = function SvgStub(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "stub_svg__a",
    x1: "53.622%",
    x2: "6.496%",
    y1: "52.948%",
    y2: "64.808%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stub_svg__b",
    x1: "16.094%",
    x2: "93.551%",
    y1: "40.826%",
    y2: "63.284%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0.917
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7AB7FF",
    fillOpacity: 0.5,
    d: "M32.188 24.049c.2.017.401.025.605.025 3.98 0 7.207-3.266 7.207-7.295 0-4.03-3.227-7.295-7.207-7.295-.575 0-1.134.068-1.67.196C30.042 4.16 25.23 0 19.46 0c-5.043 0-9.354 3.178-11.082 7.664a8.157 8.157 0 0 0-.269-.004C3.63 7.66 0 11.334 0 15.867c0 4.273 3.227 7.784 7.349 8.172.22.023.442.035.668.035h23.606c.19 0 .379-.008.565-.025Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#stub_svg__a)",
    d: "M7.812 24.049a7.13 7.13 0 0 1-.605.025C3.227 24.074 0 20.808 0 16.78c0-4.03 3.227-7.295 7.207-7.295.575 0 1.134.068 1.67.196C9.958 4.16 14.77 0 20.54 0c5.043 0 9.354 3.178 11.082 7.664.09-.003.18-.004.269-.004C36.37 7.66 40 11.334 40 15.867c0 4.273-3.227 7.784-7.349 8.172a6.41 6.41 0 0 1-.668.035H8.377c-.19 0-.379-.008-.565-.025Z",
    transform: "matrix(-1 0 0 1 40 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#stub_svg__b)",
    d: "M19.46 0c5.77 0 10.581 4.16 11.664 9.68a7.144 7.144 0 0 1 1.669-.196c3.98 0 7.207 3.266 7.207 7.295s-3.227 7.295-7.207 7.295c-.204 0-.406-.008-.605-.025l-.281.019-.284.006H8.017c-.226 0-.449-.012-.668-.035C3.227 23.65 0 20.14 0 15.867 0 11.334 3.63 7.66 8.108 7.66l.135.001.134.003.106-.267C10.278 3.053 14.517 0 19.46 0Zm0 .278c-4.627 0-8.75 2.765-10.602 6.952l-.115.27-.107.267a.28.28 0 0 1-.269.175 7.877 7.877 0 0 0-.259-.004C3.785 7.938.28 11.487.28 15.867c0 4.104 3.091 7.519 7.1 7.895.14.015.282.025.424.03l.214.004h23.606l.136-.001.29-.012.162-.011c.193.016.387.024.582.024 3.825 0 6.928-3.14 6.928-7.017 0-3.877-3.103-7.017-6.928-7.017-.546 0-1.083.063-1.604.188a.28.28 0 0 1-.34-.216C29.78 4.272 25.026.278 19.46.278Z"
  }))));
};

export default SvgStub;